import styles from './index.module.scss';

export default function ButtonLoadMoreNotes ({ onButtonGetMoreNotesClick }: { onButtonGetMoreNotesClick: () => void }) {
  const handleButtonClick = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    onButtonGetMoreNotesClick();
  };

  return (
    <div className={styles['button-load-more-notes-wrapper']}>
      <button
        className={styles['button-load-more-notes']}
        data-e='notes-more-btn'
        onClick={handleButtonClick}
        type='button'
      >
        Wczytaj więcej
      </button>
    </div>
  );
}
